import React, { useState, useEffect, useRef } from "react";
import { Map, Source, Layer, MapRef, Popup, Marker } from "react-map-gl";
import { purpleStyle } from "../Layout/LayerStyle";

const AdditionalPolygon = (props) => {
  const {
    hazardScoreMetadata, 
    selectedHazard,
    selectedTemperatureScenario,
    yearRange,
    adminPolygonData,
    source_id
   } = props;

  const [adminPolygonStyle, setAdminPolygonStyle] = useState();

  // Set active map data based on selected hazard and temperature scenario
  useEffect(() => {
    if (selectedHazard) {
      let scenarioLabel = selectedTemperatureScenario === "4.3°C" ? "ssp585" : "ssp245";
      let min = 0.1;
      let max = 1;
      if (hazardScoreMetadata[scenarioLabel].hasOwnProperty(selectedHazard)) {
        min = hazardScoreMetadata[scenarioLabel][selectedHazard][yearRange].min;
        max = hazardScoreMetadata[scenarioLabel][selectedHazard][yearRange].max;
      }

      let newPolygonStyle = JSON.parse(JSON.stringify(purpleStyle));
      newPolygonStyle.id = `${source_id}-layer`;
      newPolygonStyle.paint["fill-color"][2][1] = selectedHazard;
      newPolygonStyle.paint["fill-color"][5] = min;     
      newPolygonStyle.paint["fill-color"][7] = max;
      setAdminPolygonStyle(newPolygonStyle);
    } else {
      setAdminPolygonStyle(null);
    }
  }, [selectedHazard, selectedTemperatureScenario, yearRange]);

  return (
    <Source id={source_id} type="geojson" data={adminPolygonData}>
      <Layer {...adminPolygonStyle} />
    </Source>
  );
};

export default AdditionalPolygon;
